<script lang="ts">
  import QualityLayout from "../../../layout/QualityLayout.svelte";
  import QualityDocumentManager from "../../QualityDocument/QualityDocumentManager.svelte";
</script>

<QualityLayout>
  <QualityDocumentManager entityName="benessere animale" clfDocTypeCode="BENESANIML" withVersion={false} />
</QualityLayout>
